import { isMac } from "./Utils";


const BASE_KBD = {

    // DUEL KEYS

    TILDE: {
        key: '~',
        code: 'Backquote',  // The `Backquote` code represents the tilde/grave accent key
        keyCode: 192,       // 'Tilde' keyCode is 192
        shiftKey: true,     // Tilde requires Shift to be pressed
        label: '~',
    },

    SHIFT_ARROW_LEFT: {
        key: 'ArrowLeft',
        code: 'ArrowLeft',
        keyCode: 37,
        label: 'Shift + ←',
        shiftKey: true,
    },

    SHIFT_ARROW_RIGHT: {
        key: 'ArrowRight',
        code: 'ArrowRight',
        keyCode: 39,
        label: 'Shift + →',
        shiftKey: true,
    },

    SHIFT_ENTER: {
        key: 'Enter',
        code: 'Enter',
        keyCode: 13,
        shiftKey: true,
        label: 'Shift+Enter',
    },

    SHIFT_ARROW_LEFT: {
        key: 'ArrowLeft',
        code: 'ArrowLeft',
        keyCode: 37,
        label: '←',
        shiftKey: true,
    },


    SHIFT_ARROW_RIGHT: {
        key: 'ArrowRight',
        code: 'ArrowRight',
        keyCode: 39,
        label: '→',
        shiftKey: true,
    },


    CTRL_F5: {
        key: 'F5',
        code: 'F5',
        keyCode: 116,
        label: 'F5',
        ctrlKey: true,
    },

    CTRL_ENTER: {
        key: 'Enter',
        code: 'Enter',
        keyCode: 13,
        ctrlKey: true,
        label: 'Ctrl+Enter',
    },


    ALT_UNDERSCORE: {
        key: '_',
        code: 'Minus',
        keyCode: 189,
        altKey: true,
        shiftKey: true,
        label: '@_',
    },

    ALT_L: {
        key: 'l',
        code: 'KeyL',
        keyCode: 76,
        label: '@L',
        altKey: true,
    },

    ALT_H: {
        key: 'h',
        code: 'KeyH',
        keyCode: 72,  // 'H' keyCode is 72
        altKey: true,
        label: '@H',
    },

    ALT_T: {
        key: 't',
        code: 'KeyT',
        keyCode: 84,  // 'T' keyCode is 84
        altKey: true,
        label: '@T',
    },

    ALT_F9: {
        key: 'F9',
        code: 'F9',
        keyCode: 120,  // 'F9' keyCode is 120
        altKey: true,
        label: '@F9',
    },

    CTRL_C: {
        key: 'c',
        code: 'KeyC',
        keyCode: 67,
        ctrlKey: true,
        label: 'Ctrl+C',
    },

    CTRL_V: {
        key: 'v',
        code: 'KeyV',
        keyCode: 86,
        ctrlKey: true,
        label: 'Ctrl+V',
    },

    CTRL_S: {
        key: 's',
        code: 'KeyS',
        keyCode: 83,
        ctrlKey: true,
        label: 'Ctrl+S',
    },

    SHIFT_TAB: {
        key: 'Tab',
        code: 'Tab',
        keyCode: 9,
        shiftKey: true,
        label: 'Shift+Tab',
    },

    ALT_C: {
        key: 'c',
        code: 'KeyC',
        keyCode: 67,
        label: 'C',
        altKey: true,
    },

    ALT_D: {
        key: 'd',
        code: 'KeyD',
        keyCode: 68,
        label: 'D',
        altKey: true,
    },

    ALT_E: {
        key: 'e',
        code: 'KeyE',
        keyCode: 69,
        altKey: true,
        label: 'Alt+E',
    },

    ALT_S: {
        key: 's',
        code: 'KeyS',
        keyCode: 83,
        label: 'S',
        altKey: true,
        label: '@S',
    },

    ALT_H: {
        key: 'h',
        code: 'KeyH',
        keyCode: 72,
        label: 'H',
        altKey: true,
        label: '@H',
    },

    ALT_A: {
        key: 'a',
        code: 'KeyA',
        keyCode: 65,
        altKey: true,
        label: 'Alt+A',
    },

    CTRL_HOME: {
        key: 'Home',
        code: 'Home',
        keyCode: 36,
        ctrlKey: true,
        label: 'Ctrl+Home',
    },

    CTRL_END: {
        key: 'End',
        code: 'End',
        keyCode: 35,
        ctrlKey: true,
        label: 'Ctrl+End',
    },

    // SINGLE KEYS


    INSERT: {
        key: 'Insert',
        code: 'Insert',
        keyCode: 45,
        shiftKey: false,
        label: 'Ins',
    },

    DELETE: {
        key: 'Delete',
        code: 'Delete',
        keyCode: 46,
        shiftKey: false,
        label: 'Del',
    },


    ANY: {
        key: 'any',
        code: '',
        keyCode: 0,
        label: 'Any',
    },

    LEFT_BRACKET: {
        key: '[',
        code: 'BracketLeft',
        keyCode: 219,
        label: '[',
    },

    LEFT_BRACKET: {
        key: '[',
        code: 'BracketLeft',
        keyCode: 219,
        label: '[',
    },

    MINUS: {
        key: '-',
        code: 'Minus',
        keyCode: 189,
        label: '-',
    },
    EQUAL: {
        key: '=',
        code: 'Equal',
        keyCode: 187,
        label: '=',
    },

    LESS_THAN: {
        key: '<',
        code: 'Comma',
        keyCode: 188,
        shiftKey: true,
        label: '<',
    },

    GREATER_THAN: {
        key: '>',
        code: 'Period',
        shiftKey: true,
        keyCode: 190,
        label: '>',
    },

    PERIOD: {
        key: '.',
        code: 'Period',
        keyCode: 190,
        label: 'Period',
    },

    COMMA: {
        key: ',',
        code: 'Comma',
        keyCode: 188,
        label: 'Comma',
    },

    ARROW_DOWN: {
        key: 'ArrowDown',
        code: 'ArrowDown',
        keyCode: 40,
        label: '↓',
    },
    ARROW_UP: {
        key: 'ArrowUp',
        code: 'ArrowUp',
        keyCode: 38,
        label: '↑',
    },
    ARROW_LEFT: {
        key: 'ArrowLeft',
        code: 'ArrowLeft',
        keyCode: 37,
        label: '←',
    },
    ARROW_RIGHT: {
        key: 'ArrowRight',
        code: 'ArrowRight',
        keyCode: 39,
        label: '→',
    },
    ENTER: {
        key: 'Enter',
        code: 'Enter',
        keyCode: 13,
        shiftKey: false,
        label: 'Enter',
    },
    SLASH: {
        key: '/',
        code: 'Slash',
        keyCode: 191,
        shiftKey: false,
        label: '/',
    },
    ESCAPE: {
        key: 'Escape',
        code: 'Escape',
        keyCode: 27,
        label: 'Esc',
    },
    SPACE: {
        key: ' ',
        code: 'Space',
        keyCode: 32,
        label: 'Space',
    },
    TAB: {
        key: 'Tab',
        code: 'Tab',
        keyCode: 9,
        label: 'Tab',
    },
    SHIFT: {
        key: 'Shift',
        code: 'ShiftLeft', // or 'ShiftRight'
        keyCode: 16,
        label: 'Shift',
    },
    CONTROL: {
        key: 'Control',
        code: 'ControlLeft', // or 'ControlRight'
        keyCode: 17,
        label: 'Ctrl',
    },
    ALT: {
        key: 'Alt',
        code: 'AltLeft', // or 'AltRight'
        keyCode: 18,
        label: 'Alt',
    },
    DELETE: {
        key: 'Delete',
        code: 'Delete',
        keyCode: 46,
        label: 'Del',
    },
    BACKSPACE: {
        key: 'Backspace',
        code: 'Backspace',
        keyCode: 8,
        label: 'Backspace',
    },
    HOME: {
        key: 'Home',
        code: 'Home',
        keyCode: 36,
        label: 'Home',
    },
    END: {
        key: 'End',
        code: 'End',
        keyCode: 35,
        label: 'End',
    },
    PAGE_UP: {
        key: 'PageUp',
        code: 'PageUp',
        keyCode: 33,
        label: 'PgUp',
    },
    PAGE_DOWN: {
        key: 'PageDown',
        code: 'PageDown',
        keyCode: 34,
        label: 'PgDn',
    },
    F1: {
        key: 'F1',
        code: 'F1',
        keyCode: 112,
        label: 'F1',
    },
    F2: {
        key: 'F2',
        code: 'F2',
        keyCode: 113,
        label: 'F2',
    },
    F3: {
        key: 'F3',
        code: 'F3',
        keyCode: 114,
        label: 'F3',
    },
    F4: {
        key: 'F4',
        code: 'F4',
        keyCode: 115,
        label: 'F4',
    },
    F5: {
        key: 'F5',
        code: 'F5',
        keyCode: 116,
        label: 'F5',
    },
    F6: {
        key: 'F6',
        code: 'F6',
        keyCode: 117,
        label: 'F6',
    },
    F7: {
        key: 'F7',
        code: 'F7',
        keyCode: 118,
        label: 'F7',
    },
    F8: {
        key: 'F8',
        code: 'F8',
        keyCode: 119,
        label: 'F8',
    },
    F9: {
        key: 'F9',
        code: 'F9',
        keyCode: 120,
        label: 'F9',
    },
    F10: {
        key: 'F10',
        code: 'F10',
        keyCode: 121,
        label: 'F10',
    },
    F11: {
        key: 'F11',
        code: 'F11',
        keyCode: 122,
        label: 'F11',
    },
    F12: {
        key: 'F12',
        code: 'F12',
        keyCode: 123,
        label: 'F12',
    },
    A: {
        key: 'a',
        code: 'KeyA',
        keyCode: 65,
        label: 'A',
    },
    B: {
        key: 'b',
        code: 'KeyB',
        keyCode: 66,
        label: 'B',
    },
    C: {
        key: 'c',
        code: 'KeyC',
        keyCode: 67,
        label: 'C',
    },
    D: {
        key: 'd',
        code: 'KeyD',
        keyCode: 68,
        label: 'D',
    },
    E: {
        key: 'e',
        code: 'KeyE',
        keyCode: 69,
        label: 'E',
    },
    F: {
        key: 'f',
        code: 'KeyF',
        keyCode: 70,
        label: 'F',
    },
    G: {
        key: 'g',
        code: 'KeyG',
        keyCode: 71,
        label: 'G',
    },
    H: {
        key: 'h',
        code: 'KeyH',
        keyCode: 72,
        label: 'H',
    },
    I: {
        key: 'i',
        code: 'KeyI',
        keyCode: 73,
        label: 'I',
    },
    J: {
        key: 'j',
        code: 'KeyJ',
        keyCode: 74,
        label: 'J',
    },
    K: {
        key: 'k',
        code: 'KeyK',
        keyCode: 75,
        label: 'K',
    },
    L: {
        key: 'l',
        code: 'KeyL',
        keyCode: 76,
        label: 'L',
    },
    M: {
        key: 'm',
        code: 'KeyM',
        keyCode: 77,
        label: 'M',
    },
    N: {
        key: 'n',
        code: 'KeyN',
        keyCode: 78,
        label: 'N',
    },
    O: {
        key: 'o',
        code: 'KeyO',
        keyCode: 79,
        label: 'O',
    },
    P: {
        key: 'p',
        code: 'KeyP',
        keyCode: 80,
        label: 'P',
    },
    Q: {
        key: 'q',
        code: 'KeyQ',
        keyCode: 81,
        label: 'Q',
    },
    R: {
        key: 'r',
        code: 'KeyR',
        keyCode: 82,
        label: 'R',
    },
    S: {
        key: 's',
        code: 'KeyS',
        keyCode: 83,
        label: 'S',
    },
    T: {
        key: 't',
        code: 'KeyT',
        keyCode: 84,
        label: 'T',
    },
    U: {
        key: 'u',
        code: 'KeyU',
        keyCode: 85,
        label: 'U',
    },
    V: {
        key: 'v',
        code: 'KeyV',
        keyCode: 86,
        label: 'V',
    },
    W: {
        key: 'w',
        code: 'KeyW',
        keyCode: 87,
        label: 'W',
    },
    X: {
        key: 'x',
        code: 'KeyX',
        keyCode: 88,
        label: 'X',
    },
    Y: {
        key: 'y',
        code: 'KeyY',
        keyCode: 89,
        label: 'Y',
    },
    Z: {
        key: 'z',
        code: 'KeyZ',
        keyCode: 90,
        label: 'Z',
    },
    Digit0: {
        key: '0',
        code: 'Digit0',
        keyCode: 48,
        label: '0',
    },
    Digit1: {
        key: '1',
        code: 'Digit1',
        keyCode: 49,
        label: '1',
    },
    Digit2: {
        key: '2',
        code: 'Digit2',
        keyCode: 50,
        label: '2',
    },
    Digit3: {
        key: '3',
        code: 'Digit3',
        keyCode: 51,
        label: '3',
    },
    Digit4: {
        key: '4',
        code: 'Digit4',
        keyCode: 52,
        label: '4',
    },
    Digit5: {
        key: '5',
        code: 'Digit5',
        keyCode: 53,
        label: '5',
    },
    Digit6: {
        key: '6',
        code: 'Digit6',
        keyCode: 54,
        label: '6',
    },
    Digit7: {
        key: '7',
        code: 'Digit7',
        keyCode: 55,
        label: '7',
    },
    Digit8: {
        key: '8',
        code: 'Digit8',
        keyCode: 56,
        label: '8',
    },
    Digit9: {
        key: '9',
        code: 'Digit9',
        keyCode: 57,
        label: '9',
    },
};

const MAC_KBD = {
    PAGE_UP: {
        key: 'PageUp',
        code: 'PageUp',
        keyCode: 33,
        label: 'PgUp',
    },
    PAGE_DOWN: {
        key: 'PageDown',
        code: 'PageDown',
        keyCode: 34,
        label: 'PgDn',
    }
};

export const KBD = { ...BASE_KBD, ...(isMac ? MAC_KBD : {}) };